import {
  Description,
  Dialog,
  DialogBackdrop,
  DialogPanel,
} from "@headlessui/react";
import { CheckCircle2Icon } from "lucide-react";
import { useEffect, useState } from "react";

const Message = ({
  text,
  open,
  onClose,
}: {
  text: string;
  open: boolean;
  onClose: Function;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        onClose();
      }}
      className="relative z-50"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <DialogBackdrop className="fixed inset-0 bg-black/50" />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex w-screen items-center justify-center max-h-fit overflow-scroll p-4">
        {/* The actual dialog panel  */}
        <DialogPanel className="max-w-lg space-y-8 bg-white rounded-lg p-8">
          <div>
            <Description
              className={"text-sm text-slate-600 text-center mx-auto"}
            >
              <CheckCircle2Icon className="w-16 h-16 text-green-500 mx-auto mb-6" />
              <p className="text-lg">{text}</p>
            </Description>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default Message;
